import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";

import { RendererProps } from "../Input";

const CheckboxInput = (props: RendererProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange?.({
      target: {
        name: props.name,
        value: event.target.checked,
      },
    });
  };

  return (
    <FormGroup {...props} onChange={undefined}>
      <FormControlLabel
        control={
          <Checkbox
            checked={props.value === true}
            name={props.name}
            onChange={handleChange}
          />
        }
        label={props.label}
      />
    </FormGroup>
  );
};

export default CheckboxInput;
